<template>
  <v-card>
    <v-card-title>
      <v-layout column ma-0>
        <span class="headline"
          >Order {{ order.order_number }} - {{ order.title }}</span
        >
        <span style="font-size: 16px">{{ order.id }}</span>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeModal">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6 sm3>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">Title</span>
              <span style="font-size: 16px">{{ order.title }}&nbsp;</span>
            </v-layout>
          </v-flex>
          <v-flex xs6 sm3>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">Order number</span>
              <span style="font-size: 16px"
                >{{ order.order_number }}&nbsp;</span
              >
            </v-layout>
          </v-flex>
          <v-flex xs6 sm3>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">Status</span>
              <span style="font-size: 16px">{{ order.status }}&nbsp;</span>
            </v-layout>
          </v-flex>
          <v-flex xs6 sm3>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">Creation time</span>
              <span style="font-size: 16px"
                >{{
                  new Date(order.created * 1000).toISOString().substr(0, 10)
                }}&nbsp;</span
              >
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-combobox
              v-model="order.order_types"
              :items="types"
              label="Types"
              multiple
              chips
              disabled
            ></v-combobox>
          </v-flex>
          <v-flex xs12>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">Description</span>
              <div class="order-description" v-html="order.description"></div>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">User ID</span>
              <span style="font-size: 16px">{{ order.user_id }}&nbsp;</span>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">User business ID</span>
              <span style="font-size: 16px">{{ order.business_id }}&nbsp;</span>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">User business code</span>
              <span style="font-size: 16px"
                >{{ order.business_code }}&nbsp;</span
              >
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout column my-2>
              <span style="color: rgba(0, 0, 0, 0.54)">Operator ID</span>
              <span style="font-size: 16px">{{ order.operator_id }}&nbsp;</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" outlined @click.prevent="closeModal">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style>
.order-description {
  padding: 10px;
  border: 1px solid #eee;
}
</style>

<script>
//import { mapMutations } from "vuex";

export default {
  name: "OrderInfo",
  props: {
    order: Object
  },
  data() {
    return {
      types: [
        "classic",
        "clothing",
        "courier",
        "delivery",
        "drugstore",
        "event",
        "food",
        "housekeeping",
        "inedible",
        "rental",
        "services"
      ]
    };
  },
  computed: {},
  methods: {
    //...mapMutations(["setAppAlert"]),
    closeModal: function() {
      this.$emit("close");
    }
  }
};
</script>
